import { Box, Container } from '@mui/material'
import { useOperationsStore } from '@operations/AppProvider'
import { ShiftForm } from '@operations/features/shift/components/organisms/ShiftForm'
import { ShiftFormHeader } from '@operations/features/shift/components/organisms/ShiftFormHeader'
import { useShiftMessageHandler } from '@operations/features/shift/hooks/useShiftMessageHandler'
import { IShiftFormData } from '@operations/features/shift/models/shift.model'
import { useMinimalsTheme } from '@tom-ui/ui'
import { PATHS, useAsyncFetch, useFormStore, withAuthenticationRequired } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useNavigate, useParams } from 'react-router'

export const ShiftFormPage = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()
    const { id } = useParams<{ id: string }>()
    const navigate = useNavigate()
    const { appStore, shiftStore } = useOperationsStore()
    const { getExceptionMessage, getSuccessMessage } = useShiftMessageHandler()
    const formStore = useFormStore<IShiftFormData>()

    const shiftId = id ? Number(id) : null

    useAsyncFetch(
      async () => {
        await shiftStore.fetchData()
        shiftStore.setSelectedShift(shiftStore.items.find(x => x.id === shiftId))
      },
      [shiftId, shiftStore],
      { onError: error => appStore.setShowAlert('error', getExceptionMessage(error)) },
    )

    const onSubmit = async () => {
      try {
        const data: IShiftFormData = formStore.data

        if (formStore.validate()) {
          if (shiftId) await shiftStore.updateShift({ ...data, id: shiftId })
          else await shiftStore.createShift(data)

          appStore.setShowAlert('success', getSuccessMessage())
          navigate(PATHS.masterData.shift.url)
          shiftStore.setSelectedShift(undefined)
        }
      } catch (error) {
        appStore.setShowAlert('error', getExceptionMessage(error))
      }
    }

    return (
      <Box
        sx={{
          bgcolor: theme.palette.grey[100],
          minHeight: '100%',
        }}
      >
        <ShiftFormHeader isEdit={!!shiftId} onSubmit={onSubmit} />

        <Container sx={{ paddingY: 2 }}>
          {(shiftId === shiftStore.selectedShift?.id ||
            (!shiftId && !shiftStore.selectedShift)) && (
            <ShiftForm
              formStore={formStore}
              shift={shiftStore.selectedShift}
              shiftNames={shiftStore.shiftNames}
            />
          )}
        </Container>
      </Box>
    )
  }),
)
